import React, { useEffect, useRef, useState } from 'react'
import cn from 'classnames'
import styles from './new-requests.module.scss'
import PropTypes from 'prop-types'
import Modal from '../modal/Modal'
import ServiceRequestLineItem from './ServiceRequestLineItem'
import ServiceRequestConfirmForm from './ServiceRequestConfirm'

export default function ServiceRequestsContainer ({
  requests = [],
  refetchServiceRequests
}) {
  const detailsRef = useRef(null)
  const [confirmRequest, setConfirmRequest] = useState(null)

  useEffect(() => {
    if (detailsRef.current) {
      detailsRef.current.open = requests.length > 0
    }
  }, [requests, detailsRef])

  function closeConfirmModal () {
    setConfirmRequest(null)
  }

  return (
    <>
      <Modal isOpen={confirmRequest != null} closeModal={closeConfirmModal} className={styles['fix-request-modal']}>
        {confirmRequest != null && (
          <ServiceRequestConfirmForm
            request={confirmRequest}
            closeModal={closeConfirmModal}
            refetchServiceRequests={refetchServiceRequests}
          />
        )}
      </Modal>
      <details className='bg-green-light flex flex-col flex-nowrap w-full' ref={detailsRef}>
        <summary className='px-6 cursor-pointer flex flex-row flex-nowrap' open={requests.length > 0}>
          <span className='dispatcher-badge my-auto w-1/12 bg-white mr-6'>
            {requests.length}
          </span>
          <span className='font-size-1-5em mt-2'>New Online Schedule Requests</span>
        </summary>
        <div className={cn('flex-grow', styles.serviceRequestsWrapper)}>
          {
            requests.map((request, idx) => (
              <ServiceRequestLineItem
                index={idx}
                key={idx}
                request={request}
                refetchServiceRequests={refetchServiceRequests}
                onOpenConfirm={setConfirmRequest}
              />
            ))
          }
        </div>
      </details>
    </>
  )
}

ServiceRequestsContainer.propTypes = {
  requests: PropTypes.array,
  refetchServiceRequests: PropTypes.func.isRequired
}
